/**
 * labeled-switch.js
 */

import { Switch } from '@mui/material';


import withStyles from '@mui/styles/withStyles';


const LabeledSwitch = withStyles((theme) => ({
  root: props => ({
    width: 'auto',
    height: 22,
    margin: theme.spacing(1.5),
    padding: 0,
    ...props.style
  }),
  switchBase: {
    padding: 2,
    margin: '0px !important',
    color: theme.palette.comp.labeledSwitch.offColor,
    '&.Mui-disabled': {
      opacity: 0.5,
      '&.Mui-checked': {
        '& + $track': {
          opacity: 0.5,
        },
      },
      '& + $track': {
        backgroundColor: 'unset',
        opacity: 0.5,
      },
      '& + $thumb': {
        opacity: 0.5,
      },
    },
    '&.Mui-checked': {
      transform: 'translateX(-100%)',
      left: '100%',
      color: theme.palette.comp.labeledSwitch.onColor,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.comp.labeledSwitch.offColor,
        '&:before': {
          opacity: 1,
        },
        '&:after': {
          opacity: 0,
        },
      },
    },
  },
  input: {
    left: '-500%',
    width: '1000%',
  },
  thumb: {
    width: 18,
    height: 18,
    boxShadow: 'none',
  },
  track: {
    display: 'grid',
    gridTemplateColumns: 'min-content',
    borderRadius: 11,
    opacity: 1,
    border: `1px solid ${theme.palette.comp.labeledSwitch.borderColor}`,
    backgroundColor: theme.palette.comp.labeledSwitch.onColor,
    transition: '200ms ease-in-out',
    '&:before, &:after': {
      fontSize: 11,
      gridRowStart: 1,
      gridColumnStart: 1,
      padding: '0 6px',
      lineHeight: '21px',
      textAlign: 'center',
    },
    '&:before': {
      content: props => `"${props?.labels?.[1] || 'YES'}"`,
      opacity: 0,
      paddingRight: 23,
      color: theme.palette.comp.labeledSwitch.onColor,
    },
    '&:after': {
      content: props => `"${props?.labels?.[0] || 'NO'}"`,
      paddingLeft: 23,
      color: theme.palette.comp.labeledSwitch.offColor,
    },
  },
  checked: {},
  disabled: {},
}))(Switch);

export default LabeledSwitch;